// extracted by mini-css-extract-plugin
export default {"posts":"Posts_posts__t9gW1","box":"Posts_box__ZtR3N","btnLoad":"Posts_btnLoad__WP3ac"};